import React, { createContext, useContext, useState, useRef, useCallback } from 'react';

const AudioPlayerContext = createContext();

export const useAudioPlayer = () => {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayer must be used within AudioPlayerProvider');
  }
  return context;
};

export const AudioPlayerProvider = ({ children }) => {
  const [activePlayerId, setActivePlayerId] = useState(null);
  const playersRef = useRef({});

  // Регистрация плеера
  const registerPlayer = useCallback((id, controls) => {
    playersRef.current[id] = controls;
  }, []);

  // Удаление плеера
  const unregisterPlayer = useCallback((id) => {
    delete playersRef.current[id];
  }, []);

  // Воспроизведение плеера с остановкой других
  const playPlayer = useCallback((id) => {
    // Останавливаем все другие плееры
    Object.keys(playersRef.current).forEach((key) => {
      if (key !== String(id) && playersRef.current[key]) {
        playersRef.current[key].pause();
      }
    });
    
    setActivePlayerId(id);
  }, []);

  const playNext = useCallback((currentId) => {
  const playerIds = Object.keys(playersRef.current);
  const currentIndex = playerIds.indexOf(String(currentId));
  
  if (currentIndex !== -1 && currentIndex < playerIds.length - 1) {
    const nextId = playerIds[currentIndex + 1];
    if (playersRef.current[nextId]) {
      playersRef.current[nextId].play();
    }
  }
}, []);

  // Остановка плеера
  const pausePlayer = useCallback((id) => {
    if (activePlayerId === id) {
      setActivePlayerId(null);
    }
  }, [activePlayerId]);

  // Проверка, активен ли плеер
  const isActive = useCallback((id) => {
    return activePlayerId === id;
  }, [activePlayerId]);

  const value = {
    activePlayerId,
    registerPlayer,
    unregisterPlayer,
    playPlayer,
    pausePlayer,
    isActive,
    playNext
  };

  return (
    <AudioPlayerContext.Provider value={value}>
      {children}
    </AudioPlayerContext.Provider>
  );
};

export default AudioPlayerContext;